// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.asset-list {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;
}

/* ----------------------------- */
/* Barre de titre                 */
/* ----------------------------- */

.asset-list-header {
    flex-shrink: 0;
    display: grid;
    grid-template-columns: 90px 100px minmax(0, 1fr) 60px 30px;

    height: 30px;
    align-items: center;

    background: transparent;
    color: var(--default-icon-color);

    font-weight: bold;
    font-size: 13px;

    box-sizing: border-box;
}

.asset-list-header > div {
    padding: 0 6px;
    box-sizing: border-box;
}

/* ----------------------------- */
/* Contenu scrollable             */
/* ----------------------------- */

.asset-list-content {
    height: 140px;
    

    overflow-y: auto;
    overflow-x: hidden;

    /* Firefox */
    scrollbar-width: none;

    /* IE / anciennes versions Edge */
    -ms-overflow-style: none;
}

/* Chrome / Edge / Safari */
.asset-list-content::-webkit-scrollbar {
    display: none;
}

/* ----------------------------- */
/* Lignes                         */
/* ----------------------------- */

.asset-list-row {
    display: grid;
    grid-template-columns: 90px 100px minmax(0, 1fr) 60px 30px;

    min-height: 30px;
    align-items: center;

    font-size: 13px;

    box-sizing: border-box;
}

.asset-list-row-alt {
    background: #181818;
}

.asset-list-row:hover {
    background: #505050;
}

.asset-list-row > div {
    padding: 0 6px;
    box-sizing: border-box;
}

/* ----------------------------- */
/* Colonnes                       */
/* ----------------------------- */

.asset-col-number {
    text-align: right;
}

.asset-col-type {
    text-align: left;
}

.asset-col-title {
    text-align: left;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.asset-col-count {
    text-align: center;
}

.asset-col-button {
    display: flex;
    align-items: center;
    justify-content: center;
}

/* ----------------------------- */
/* Bouton +                       */
/* ----------------------------- */

.asset-add-button {
    width: 20px;
    height: 20px;

    padding: 0;
    margin: 0;

    border: 1px solid #888;
    border-radius: 3px;

    background: var(--default-icon-color);
    color: #333;

    font-size: 16px;
    line-height: 16px;

    cursor: pointer;
}

.asset-add-button:hover {
    background: #ddd;
}

.asset-add-button:active {
    background: #bbb;
}
`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/appmediaassets/mergedialog/assetsubtitlelist/assetsubtitlelist.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA,kCAAkC;AAClC,mCAAmC;AACnC,kCAAkC;;AAElC;IACI,cAAc;IACd,aAAa;IACb,0DAA0D;;IAE1D,YAAY;IACZ,mBAAmB;;IAEnB,uBAAuB;IACvB,gCAAgC;;IAEhC,iBAAiB;IACjB,eAAe;;IAEf,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA,kCAAkC;AAClC,mCAAmC;AACnC,kCAAkC;;AAElC;IACI,aAAa;;;IAGb,gBAAgB;IAChB,kBAAkB;;IAElB,YAAY;IACZ,qBAAqB;;IAErB,iCAAiC;IACjC,wBAAwB;AAC5B;;AAEA,2BAA2B;AAC3B;IACI,aAAa;AACjB;;AAEA,kCAAkC;AAClC,mCAAmC;AACnC,kCAAkC;;AAElC;IACI,aAAa;IACb,0DAA0D;;IAE1D,gBAAgB;IAChB,mBAAmB;;IAEnB,eAAe;;IAEf,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,sBAAsB;AAC1B;;AAEA,kCAAkC;AAClC,mCAAmC;AACnC,kCAAkC;;AAElC;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;;IAEhB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA,kCAAkC;AAClC,mCAAmC;AACnC,kCAAkC;;AAElC;IACI,WAAW;IACX,YAAY;;IAEZ,UAAU;IACV,SAAS;;IAET,sBAAsB;IACtB,kBAAkB;;IAElB,qCAAqC;IACrC,WAAW;;IAEX,eAAe;IACf,iBAAiB;;IAEjB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".asset-list {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    box-sizing: border-box;\n}\n\n/* ----------------------------- */\n/* Barre de titre                 */\n/* ----------------------------- */\n\n.asset-list-header {\n    flex-shrink: 0;\n    display: grid;\n    grid-template-columns: 90px 100px minmax(0, 1fr) 60px 30px;\n\n    height: 30px;\n    align-items: center;\n\n    background: transparent;\n    color: var(--default-icon-color);\n\n    font-weight: bold;\n    font-size: 13px;\n\n    box-sizing: border-box;\n}\n\n.asset-list-header > div {\n    padding: 0 6px;\n    box-sizing: border-box;\n}\n\n/* ----------------------------- */\n/* Contenu scrollable             */\n/* ----------------------------- */\n\n.asset-list-content {\n    height: 140px;\n    \n\n    overflow-y: auto;\n    overflow-x: hidden;\n\n    /* Firefox */\n    scrollbar-width: none;\n\n    /* IE / anciennes versions Edge */\n    -ms-overflow-style: none;\n}\n\n/* Chrome / Edge / Safari */\n.asset-list-content::-webkit-scrollbar {\n    display: none;\n}\n\n/* ----------------------------- */\n/* Lignes                         */\n/* ----------------------------- */\n\n.asset-list-row {\n    display: grid;\n    grid-template-columns: 90px 100px minmax(0, 1fr) 60px 30px;\n\n    min-height: 30px;\n    align-items: center;\n\n    font-size: 13px;\n\n    box-sizing: border-box;\n}\n\n.asset-list-row-alt {\n    background: #181818;\n}\n\n.asset-list-row:hover {\n    background: #505050;\n}\n\n.asset-list-row > div {\n    padding: 0 6px;\n    box-sizing: border-box;\n}\n\n/* ----------------------------- */\n/* Colonnes                       */\n/* ----------------------------- */\n\n.asset-col-number {\n    text-align: right;\n}\n\n.asset-col-type {\n    text-align: left;\n}\n\n.asset-col-title {\n    text-align: left;\n\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n\n.asset-col-count {\n    text-align: center;\n}\n\n.asset-col-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n/* ----------------------------- */\n/* Bouton +                       */\n/* ----------------------------- */\n\n.asset-add-button {\n    width: 20px;\n    height: 20px;\n\n    padding: 0;\n    margin: 0;\n\n    border: 1px solid #888;\n    border-radius: 3px;\n\n    background: var(--default-icon-color);\n    color: #333;\n\n    font-size: 16px;\n    line-height: 16px;\n\n    cursor: pointer;\n}\n\n.asset-add-button:hover {\n    background: #ddd;\n}\n\n.asset-add-button:active {\n    background: #bbb;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
